(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facetfine-membership-announcement"] && !Shopify.designMode) return;
  try {
    (function(){
function init(){
var p=document.getElementById('ff-membership-announcement');
if(!p||p.dataset.initialized)return;
p.dataset.initialized='true';
if(typeof p.showModal!=='function')return;
var preview=p.dataset.preview==='true',key='ff-membership-announcement-v2',seen=0;
try{seen=Number(localStorage.getItem(key)||0)}catch(e){}
if(!preview&&Date.now()-seen<86400000)return;
function close(){p.close()}
p.querySelector('.ff-ma-close').addEventListener('click',close);
p.querySelector('.ff-ma-later').addEventListener('click',close);
p.addEventListener('click',function(e){if(e.target===p){var r=p.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close()}});
// Let the homepage SMS signup finish before showing the membership offer.
var earliestOpen = Date.now() + 30000, lastOtherDialog = 0, attempts = 0;
function hasOtherDialog(root) {
  var dialogs = root.querySelectorAll('dialog[open], [role="dialog"], [aria-modal="true"]');
  for (var i = 0; i < dialogs.length; i++) {
    var dialog = dialogs[i];
    if (dialog !== p && dialog.getClientRects().length &&
        getComputedStyle(dialog).visibility !== 'hidden' &&
        getComputedStyle(dialog).display !== 'none') return true;
  }
  var elements = root.querySelectorAll('*');
  for (var j = 0; j < elements.length; j++) {
    if (elements[j].shadowRoot && hasOtherDialog(elements[j].shadowRoot)) return true;
  }
  return false;
}
function showWhenReady() {
  if (!p.isConnected || p.open || ++attempts > 300) return;
  var now = Date.now();
  if (hasOtherDialog(document)) lastOtherDialog = now;
  if (document.visibilityState !== 'visible' || now < earliestOpen ||
      (lastOtherDialog && now - lastOtherDialog < 15000)) {
    setTimeout(showWhenReady, 1000);
    return;
  }
  p.showModal();
  if (!preview) { try { localStorage.setItem(key, String(now)); } catch(e) {} }
}
setTimeout(showWhenReady, 1000);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facetfine-onyx-special"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('ff-sale-popup');
  if (!dialog || !dialog.showModal || window.Shopify?.designMode) return;
  const end = Date.parse(dialog.dataset.end);
  if (!Number.isFinite(end) || Date.now() >= end) return;
  const key = 'ff-sitewide-sale-oct26-27-2026';
  let seen = false;
  try { seen = sessionStorage.getItem(key) === '1'; } catch (_) {}
  if (seen) return;
  const hours = dialog.querySelector('[data-hours]');
  const minutes = dialog.querySelector('[data-minutes]');
  const seconds = dialog.querySelector('[data-seconds]');
  let ticker;
  const update = () => {
    const remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
    hours.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
    minutes.textContent = String(Math.floor(remaining / 60) % 60).padStart(2, '0');
    seconds.textContent = String(remaining % 60).padStart(2, '0');
    if (!remaining) { if (dialog.open) dialog.close(); clearInterval(ticker); }
    return remaining > 0;
  };
  let attempts = 0;
  const show = () => {
    if (Date.now() >= end || location.pathname.split('/').some(part => ['cart', 'checkout', 'checkouts', 'account'].includes(part)) || attempts++ > 90) return;
    const busy = Array.from(document.querySelectorAll('dialog[open], [role="dialog"], .form-container-ref')).some(el => el !== dialog && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
    if (busy) { setTimeout(show, 2000); return; }
    if (!update()) return;
    document.body.appendChild(dialog);
    dialog.showModal();
    ticker = setInterval(update, 1000);
    try { sessionStorage.setItem(key, '1'); } catch (_) {}
  };
  dialog.querySelector('.ff-sale-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => clearInterval(ticker));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  setTimeout(show, 8000);
})();
  } catch(e) { console.error(e); }
})();

})();
